import moment from "moment";
import { Task } from "../../api/Tasks";

// DayGroups is the three groups one calendar day is drawn in, in the order they're
// drawn: what has been ticked off, what's left of the day's own, and what was carried
// in from a day that has passed.
export type DayGroups = {
    done: Task[];
    open: Task[];
    carried: Task[];
};

// groupDayTasks splits one day's tasks into the groups it's drawn in. The open and
// carried groups keep the order they were given, which is the order they were dragged
// into. The done group is ordered by when each task was ticked off, so the one just
// completed joins the end of it.
export function groupDayTasks(tasks: Task[]): DayGroups {
    return {
        done: tasks.filter(task => !task.carriedOver && !!task.completedAt)
            .sort((a, b) => completedAt(a) - completedAt(b) || a.id - b.id),
        open: tasks.filter(task => !task.carriedOver && !task.completedAt),
        carried: tasks.filter(task => task.carriedOver),
    };
}

function completedAt(task: Task) {
    return task.completedAt ? moment(task.completedAt).valueOf() : 0;
}

// calendarOrder lays the tasks out in the order the calendar draws them: day by day,
// and within each day group by group
export function calendarOrder(tasks: Task[]): Task[] {
    const days = Array.from(new Set(tasks.map(task => task.showOn || ""))).filter(day => !!day).sort();

    return days.flatMap(day => {
        const groups = groupDayTasks(tasks.filter(task => task.showOn === day));
        return groups.done.concat(groups.open, groups.carried);
    });
}
